import React from 'react'
import { type LucideProps } from 'lucide-react'

const CompareCards : React.FC<LucideProps> = (props: LucideProps) => (
  <svg
  width={20}
  height={23}
  viewBox="0 0 20 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M19.4455 6.20569C19.2537 5.96777 18.9774 5.8181 18.6704 5.78358L13.1792 5.20797V1.8579C13.1792 1.22473 12.6611 0.706696 12.028 0.706696H1.66708C1.0339 0.706696 0.515869 1.22473 0.515869 1.8579V16.8236C0.515869 17.4568 1.0339 17.9748 1.66708 17.9748H5.81532L5.53903 20.6071C5.47379 21.2365 5.93426 21.8044 6.56359 21.8735L16.867 22.9556C16.9092 22.9594 16.9475 22.9633 16.9898 22.9633C17.2507 22.9633 17.504 22.875 17.7112 22.7062C17.9491 22.5143 18.0988 22.238 18.1333 21.931L19.6989 7.04597C19.7296 6.73899 19.6414 6.43967 19.4495 6.20176L19.4455 6.20569ZM1.66698 17.2073C1.45593 17.2073 1.28324 17.0347 1.28324 16.8236V1.8579C1.28324 1.64686 1.45592 1.47417 1.66698 1.47417H12.0279C12.2389 1.47417 12.4116 1.64685 12.4116 1.8579V5.12734L8.36711 4.7014C8.06012 4.6707 7.76081 4.75896 7.52289 4.95084C7.28497 5.14272 7.13531 5.419 7.10078 5.72598L5.89585 17.2074L1.66698 17.2073ZM17.3695 21.8507C17.3579 21.9543 17.3081 22.0425 17.2275 22.1077C17.1469 22.173 17.0471 22.1998 16.9473 22.1922L6.64397 21.11C6.43293 21.087 6.27943 20.899 6.30244 20.6879L7.86808 5.80285C7.87959 5.69925 7.92948 5.61099 8.00622 5.54576C8.08681 5.48053 8.18658 5.44983 8.28636 5.46134L18.5897 6.54348C18.6933 6.55499 18.7816 6.60487 18.8468 6.68162C18.9121 6.7622 18.9428 6.86198 18.9312 6.96176L17.3656 21.8468L17.3695 21.8507Z"
    fill="#949494"
  />
</svg>

)

export default CompareCards 
